import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { keys } from "../queryKeys.js";
import * as api from "../api/inboundWebhooks.js";

export function useInboundWebhooks(options = {}) {
  return useQuery({
    queryKey: keys.inboundWebhooks.list,
    queryFn: api.fetchInboundWebhooks,
    ...options,
  });
}

export function useCreateInboundWebhook() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createInboundWebhook,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.inboundWebhooks.all }),
  });
}

export function useUpdateInboundWebhook() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => api.updateInboundWebhook(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.inboundWebhooks.all }),
  });
}

export function useDeleteInboundWebhook() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.deleteInboundWebhook,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.inboundWebhooks.all }),
  });
}

export function useRotateInboundWebhookToken() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.rotateInboundWebhookToken,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.inboundWebhooks.all }),
  });
}

export function useInboundWebhookEvents(id, options = {}) {
  return useQuery({
    queryKey: keys.inboundWebhooks.events(id),
    queryFn: () => api.fetchInboundWebhookEvents(id),
    enabled: !!id,
    ...options,
  });
}
